import { render, staticRenderFns } from "./RelationshipComponent.vue?vue&type=template&id=320d37e2"
import script from "./RelationshipComponent.vue?vue&type=script&lang=js"
export * from "./RelationshipComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports